/* uuhu-header.js — 施策J(診断 docs/施策J_デザイン診断_2026-09-18.md)。書き込みは scripts/apply_design_j.py */
(function () {
  'use strict';
  var d = document;
  var header = d.querySelector('.section-header');

  /* 1) 深さでヘッダーを締める。トップはヒーローの下端、ほかのページは 240px を境にする */
  var hero = d.querySelector('[id$="__hero"]');
  var line = 240;
  function measure() {
    if (hero) { var r = hero.getBoundingClientRect(); line = (window.pageYOffset || 0) + r.bottom - 60; }
  }
  measure();
  window.addEventListener('load', measure);
  window.addEventListener('resize', measure);

  /* 2) 商品ページ: 「カートに追加」が画面の上へ消えたら小さなバーを出す */
  var submit = d.querySelector('.product-form__submit');
  var bar = null;
  if (submit) {
    var titleEl = d.querySelector('.product__title h1');
    var priceEl = d.querySelector('.product__info-container .price-item--regular');
    bar = d.createElement('div');
    bar.className = 'uuhu-atc';
    bar.innerHTML = '<div class="uuhu-atc__title"></div><div class="uuhu-atc__price"></div>' +
      '<button type="button" class="button">カートに追加する</button>';
    bar.querySelector('.uuhu-atc__title').textContent = titleEl ? titleEl.textContent.trim() : '';
    bar.querySelector('.uuhu-atc__price').textContent = priceEl ? priceEl.textContent.trim() : '';
    bar.querySelector('button').addEventListener('click', function () { submit.click(); });
    d.body.appendChild(bar);
  }

  function onScroll() {
    var y = window.pageYOffset || d.documentElement.scrollTop || 0;
    if (header) header.classList.toggle('uuhu-compact', y > line);
    if (bar) {
      var on = submit.getBoundingClientRect().bottom < 0;
      d.body.classList.toggle('uuhu-atc-on', on);
      if (on && header && window.innerWidth >= 750) {
        bar.style.top = Math.max(0, header.getBoundingClientRect().bottom) + 'px';
      }
      /* 下見テーマの表示中は Shopify のプレビューバー(`#PBarNextFrameWrapper`。あとから差し込まれる。2026-09-18 実測)が画面下に重なるので、
         その高さぶん持ち上げる。公開後は iframe が無いので何もしない */
      var pbar = d.getElementById('PBarNextFrameWrapper') || d.getElementById('preview-bar-iframe');
      bar.style.bottom = (pbar && window.innerWidth < 750) ? pbar.offsetHeight + 'px' : '';
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* 3) 商品ページ: ほかの色。同じラインのコレクションを products.json で読み、価格の下に並べる */
  var LINES = [["着るタオル パイル&ガーゼ", "kiru-towel"], ["着るタオル エアリーガーゼ", "kiru-towel-airy-gauze"], ["着るタオル Kids", "kiru-towel-kids"], ["今治タオルTシャツ", "imabari-towel-tshirt"], ["銀のまくだけ", "makudake-pillowcase"]];
  var titleNode = d.querySelector('.product__title h1');
  var priceBlock = d.querySelector('.product__info-container [id^="price-template"]');
  if (titleNode && priceBlock && window.fetch) {
    var title = titleNode.textContent.trim();
    var hit = null;
    for (var i = 0; i < LINES.length; i++) { if (title.indexOf(LINES[i][0]) === 0) { hit = LINES[i]; break; } }
    if (hit) {
      var here = decodeURIComponent(location.pathname).split('/products/')[1] || '';
      fetch('/collections/' + hit[1] + '/products.json?limit=50', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j.products) return;
          var items = j.products.filter(function (p) { return p.title.indexOf(hit[0]) === 0 && p.images && p.images.length; });
          if (items.length < 2) return;
          var wrap = d.createElement('div');
          wrap.className = 'uuhu-colors';
          var label = d.createElement('div');
          label.className = 'uuhu-colors__label';
          label.textContent = 'カラー（' + items.length + '色）';
          var ul = d.createElement('ul');
          ul.className = 'uuhu-colors__list';
          items.forEach(function (p) {
            var li = d.createElement('li');
            li.className = 'uuhu-colors__item' + (p.handle === here ? ' is-current' : '') +
              (p.variants && p.variants.length && !p.variants[0].available ? ' is-soldout' : '');
            var a = d.createElement('a');
            a.href = '/products/' + p.handle;
            var img = d.createElement('img');
            var src = p.images[0].src;
            img.src = src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=200';
            img.alt = p.title;
            img.loading = 'lazy';
            var s = d.createElement('span');
            s.textContent = p.title.slice(hit[0].length).trim() || p.title;
            a.appendChild(img); a.appendChild(s); li.appendChild(a); ul.appendChild(li);
          });
          wrap.appendChild(label); wrap.appendChild(ul);
          priceBlock.parentNode.insertBefore(wrap, priceBlock.nextSibling);
        })
        .catch(function () {});
    }
  }

  /* 4) 商品ページ: 本文を h2 ごとに details で包む。HTML の中身は動かすだけで、消さない */
  var desc = d.querySelector('.product__description');
  if (desc) {
    var kids = Array.prototype.slice.call(desc.children);
    var groups = [], cur = null;
    kids.forEach(function (el) {
      if (el.tagName === 'H2') { cur = { h: el, body: [] }; groups.push(cur); }
      else if (cur) { cur.body.push(el); }
    });
    if (groups.length >= 2) {
      groups.forEach(function (g, i) {
        var det = d.createElement('details');
        det.className = 'uuhu-fold';
        if (i === 0) det.open = true;
        var sum = d.createElement('summary');
        desc.insertBefore(det, g.h);
        sum.appendChild(g.h);
        det.appendChild(sum);
        var body = d.createElement('div');
        body.className = 'uuhu-fold__body';
        g.body.forEach(function (el) { body.appendChild(el); });
        det.appendChild(body);
      });
    }
  }
})();
